export default "__VITE_ASSET__a51b6569__"